import React from 'react';
import PropTypes from 'prop-types';
import ExtraTypeCode from '../SetupItemLookup/ExtraTypeCode';

const BundleIncludesCaption = ({bookedExtras}) => (
  <span>
    Includes{' '}
    {bookedExtras.map((bookedExtra, index) =>
      <React.Fragment key={`${bookedExtra.extraTypeId}-${index}`}>
        <ExtraTypeCode id={bookedExtra.extraTypeId}/>
        {bookedExtra.quantity > 1 ? ` x${bookedExtra.quantity}` : ''}
        {index < bookedExtras.length - 1 ? ', ' : ''}
      </React.Fragment>
    )}
  </span>
);

BundleIncludesCaption.propTypes = {
  bookedExtras: PropTypes.arrayOf(PropTypes.shape({
    extraTypeId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    quantity: PropTypes.number,
  })).isRequired,
};

export default BundleIncludesCaption;
